export interface SubscriptionStatus {
  isSubscribed: boolean;
  tier: string;
  status: 'active' | 'canceled' | 'past_due' | 'unpaid' | 'unsubscribed';
  currentPeriodEnd?: Date;
}

export interface SubscriptionModalData {
  subscriptionStatus: SubscriptionStatus | null;
  subscriptionUrl: string;
}

export class ApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public subscriptionUrl?: string,
    public subscriptionStatus?: SubscriptionStatus
  ) {
    super(message);
    this.name = 'ApiError';
  }
} 